/* ==========================================================================
   KINOVA — KINO TAFSILOTI: baho (10 yulduz), izohlar, ulashish
   (17-bosqich)
   ==========================================================================
   Manba markup: resources/views/components/film-detail.blade.php

   ⚠️ Mustaqil modul: `main.js`/`components.js`/`details.js` — dizayn
      manbasidan bayt-bayt ajratilgan fayllar, ularga TEGILMAYDI. Bu
      modul o'zi kerakli elementlarni topadi va topmasa jimgina
      chiqib ketadi (`if (!root) return;`), shuning uchun boshqa
      sahifalarga zarari yo'q.

   ⚠️ CSRF `window.KINOVA_CSRF_TOKEN` orqali (yangi <meta> teg
      qo'shilmaydi — `partials/head.blade.php` bayt-ko'zgulangan).
   ========================================================================== */
(function (global) {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function esc(v) {
    return String(v === null || v === undefined ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function csrf() {
    return global.KINOVA_CSRF_TOKEN || '';
  }

  function jsonFetch(url, options) {
    var opts = options || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }, opts.headers || {});

    if (opts.body) {
      opts.headers['Content-Type'] = 'application/json';
      opts.headers['X-CSRF-TOKEN'] = csrf();
    }

    return fetch(url, opts).then(function (r) {
      return r.json()
        .catch(function () { return {}; })
        .then(function (body) { return { status: r.status, body: body }; });
    });
  }

  /* ══ 1) BAHO — 10 ta yulduz ═════════════════════════════════════ */
  function wireRating(root) {
    var box = document.getElementById('filmRate');
    if (!box) return;

    var starsWrap = document.getElementById('filmRateStars');
    var avgEl = document.getElementById('filmRateAvg');
    var countEl = document.getElementById('filmRateCount');
    var hintEl = document.getElementById('filmRateHint');
    var clearBtn = document.getElementById('filmRateClear');
    if (!starsWrap) return;

    var slug = root.getAttribute('data-slug') || '';
    var authed = root.getAttribute('data-authed') === '1';
    var loginUrl = root.getAttribute('data-login-url') || '/login';
    var stars = Array.prototype.slice.call(starsWrap.querySelectorAll('.film-star'));
    var mine = parseInt(root.getAttribute('data-my-rating'), 10);
    if (isNaN(mine)) mine = 0;

    function paint(upto, preview) {
      stars.forEach(function (s, i) {
        var on = i < upto;
        s.classList.toggle(preview ? 'is-preview' : 'is-on', on);
        if (!preview) s.classList.remove('is-preview');
        s.setAttribute('aria-checked', String(!preview && i + 1 === mine));
      });
      if (!preview) stars.forEach(function (s) { s.classList.remove('is-preview'); });
    }

    function applySummary(data) {
      mine = data.mine || 0;
      root.setAttribute('data-my-rating', mine ? String(mine) : '');
      if (avgEl) avgEl.textContent = data.count > 0 ? Number(data.average).toFixed(1) : '—';
      if (countEl) countEl.textContent = data.count > 0 ? data.count + ' ta baho' : "Hali baho yo'q";
      stars.forEach(function (s, i) {
        s.classList.toggle('is-on', i < mine);
        s.classList.remove('is-preview');
        s.setAttribute('aria-checked', String(i + 1 === mine));
      });
      if (hintEl) {
        hintEl.textContent = mine
          ? 'Siz ' + mine + " ball qo'ygansiz. O'zgartirish uchun boshqa yulduzni bosing."
          : "Yulduzchani bosib baho qo'ying.";
      }
      if (clearBtn) clearBtn.hidden = !mine;
    }

    /* Sichqoncha yulduzlar ustida — oldindan ko'rish. */
    stars.forEach(function (star, idx) {
      star.addEventListener('mouseenter', function () {
        if (!authed) return;
        stars.forEach(function (s, i) { s.classList.toggle('is-preview', i <= idx); });
      });
      star.addEventListener('click', function () {
        if (!authed) {
          global.location.href = loginUrl;

          return;
        }

        var value = parseInt(star.getAttribute('data-value'), 10) || 0;
        if (!value) return;

        jsonFetch('/kino/' + encodeURIComponent(slug) + '/baho', {
          method: 'POST',
          body: JSON.stringify({ value: value })
        }).then(function (res) {
          if (res.status === 200 && res.body && res.body.ok) {
            applySummary(res.body);

            return;
          }
          if (hintEl) hintEl.textContent = (res.body && res.body.message) || 'Baho saqlanmadi. Qayta urinib ko\'ring.';
        }).catch(function () {
          if (hintEl) hintEl.textContent = 'Tarmoq xatosi. Qayta urinib ko\'ring.';
        });
      });
    });

    starsWrap.addEventListener('mouseleave', function () {
      stars.forEach(function (s, i) {
        s.classList.remove('is-preview');
        s.classList.toggle('is-on', i < mine);
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        jsonFetch('/kino/' + encodeURIComponent(slug) + '/baho', {
          method: 'DELETE',
          body: JSON.stringify({})
        }).then(function (res) {
          if (res.status === 200 && res.body && res.body.ok) applySummary(res.body);
        });
      });
    }

    paint(mine, false);
  }

  /* ══ 2) ULASHISH — havolani nusxalash ═══════════════════════════ */
  function wireShare() {
    document.querySelectorAll('[data-share-copy]').forEach(function (btn) {
      var row = btn.closest('.share-row');
      var url = (row && row.getAttribute('data-share-url')) || global.location.href;

      btn.addEventListener('click', function () {
        var done = function () {
          var label = btn.querySelector('span');
          var old = label ? label.textContent : '';
          btn.classList.add('is-copied');
          if (label) label.textContent = 'Nusxalandi';
          setTimeout(function () {
            btn.classList.remove('is-copied');
            if (label) label.textContent = old;
          }, 1800);
        };

        if (global.navigator && global.navigator.clipboard && global.navigator.clipboard.writeText) {
          global.navigator.clipboard.writeText(url).then(done).catch(done);

          return;
        }

        /* Zaxira: `clipboard` yo'q (eski brauzer yoki HTTP). */
        var t = document.createElement('textarea');
        t.value = url;
        t.setAttribute('readonly', '');
        t.style.position = 'fixed';
        t.style.opacity = '0';
        document.body.appendChild(t);
        t.select();
        try { document.execCommand('copy'); } catch (e) { /* jim */ }
        document.body.removeChild(t);
        done();
      });
    });
  }

  /* ══ 3) IZOHLAR ═════════════════════════════════════════════════ */
  function commentHTML(c) {
    var replies = (c.replies || []).map(commentHTML).join('');

    return '<article class="comment" data-id="' + esc(c.id) + '">' +
      '<span class="comment__avatar">' + esc(c.initials) + '</span>' +
      '<div class="comment__body">' +
      '<div class="comment__head">' +
      '<span class="comment__author">' + esc(c.author) + '</span>' +
      '<span class="comment__date">' + esc(c.createdAt) + '</span>' +
      '</div>' +
      '<p class="comment__text">' + esc(c.body).replace(/\n/g, '<br>') + '</p>' +
      '<div class="comment__actions">' +
      '<button type="button" class="comment__action" data-reply="' + esc(c.id) +
      '" data-author="' + esc(c.author) + '">Javob berish</button>' +
      (c.own ? '<button type="button" class="comment__action comment__action--danger" data-delete="' +
        esc(c.id) + '">O\'chirish</button>' : '') +
      '</div>' +
      (replies ? '<div class="comment__replies">' + replies + '</div>' : '') +
      '</div>' +
      '</article>';
  }

  function wireComments() {
    var section = document.getElementById('filmComments');
    if (!section) return;

    var slug = section.getAttribute('data-slug') || '';
    var listEl = document.getElementById('filmCommentsList');
    var countEl = document.getElementById('filmCommentsCount');
    var moreBtn = document.getElementById('filmCommentsMore');
    var form = document.getElementById('filmCommentForm');
    var bodyEl = document.getElementById('filmCommentBody');
    var parentEl = document.getElementById('filmCommentParent');
    var replyBar = document.getElementById('filmCommentReplying');
    var replyCancel = document.getElementById('filmCommentReplyCancel');
    var counterEl = document.getElementById('filmCommentCounter');
    var alertEl = document.getElementById('filmCommentAlert');
    var submitBtn = document.getElementById('filmCommentSubmit');

    var page = 0;
    var loaded = [];

    function render() {
      if (!listEl) return;

      if (!loaded.length) {
        listEl.innerHTML = '<p class="film-comments__empty">Hali izoh yo\'q. Birinchi bo\'lib fikr bildiring.</p>';

        return;
      }

      listEl.innerHTML = loaded.map(commentHTML).join('');
    }

    function setCount(n) {
      if (countEl) countEl.textContent = n > 0 ? '(' + n + ')' : '';
    }

    function load(next) {
      var want = next ? page + 1 : 1;

      jsonFetch('/kino/' + encodeURIComponent(slug) + '/izohlar?page=' + want)
        .then(function (res) {
          if (res.status !== 200 || !res.body || !res.body.ok) {
            if (listEl && !loaded.length) {
              listEl.innerHTML = '<p class="film-comments__empty">Izohlarni yuklab bo\'lmadi.</p>';
            }

            return;
          }

          page = res.body.page;
          loaded = next ? loaded.concat(res.body.comments || []) : (res.body.comments || []);
          setCount(res.body.total || 0);
          render();
          if (moreBtn) moreBtn.hidden = !res.body.hasMore;
        })
        .catch(function () {
          if (listEl && !loaded.length) {
            listEl.innerHTML = '<p class="film-comments__empty">Tarmoq xatosi.</p>';
          }
        });
    }

    if (moreBtn) moreBtn.addEventListener('click', function () { load(true); });

    /* Javob berish / o'chirish — ro'yxat dinamik, shuning uchun
       delegatsiya (bitta ishlovchi butun ro'yxat uchun). */
    if (listEl) {
      listEl.addEventListener('click', function (e) {
        var replyBtn = e.target.closest('[data-reply]');
        if (replyBtn && parentEl && bodyEl) {
          parentEl.value = replyBtn.getAttribute('data-reply');
          if (replyBar) {
            replyBar.hidden = false;
            var span = replyBar.querySelector('span');
            if (span) span.textContent = replyBtn.getAttribute('data-author') + ' ga javob yozyapsiz';
          }
          bodyEl.focus();
          bodyEl.scrollIntoView({ block: 'center', behavior: 'smooth' });

          return;
        }

        var delBtn = e.target.closest('[data-delete]');
        if (delBtn) {
          jsonFetch('/izohlar/' + delBtn.getAttribute('data-delete'), {
            method: 'DELETE',
            body: JSON.stringify({})
          }).then(function (res) {
            if (res.status === 200 && res.body && res.body.ok) load(false);
          });
        }
      });
    }

    if (replyCancel) {
      replyCancel.addEventListener('click', function () {
        if (parentEl) parentEl.value = '';
        if (replyBar) replyBar.hidden = true;
      });
    }

    if (bodyEl && counterEl) {
      var sync = function () { counterEl.textContent = bodyEl.value.length + ' / 2000'; };
      bodyEl.addEventListener('input', sync);
      sync();
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (alertEl) alertEl.hidden = true;

        var payload = {
          body: bodyEl ? bodyEl.value : '',
          parent_id: parentEl && parentEl.value ? Number(parentEl.value) : null
        };

        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Yuborilmoqda…'; }

        jsonFetch('/kino/' + encodeURIComponent(slug) + '/izohlar', {
          method: 'POST',
          body: JSON.stringify(payload)
        }).then(function (res) {
          if (res.status === 201 && res.body && res.body.ok) {
            if (bodyEl) bodyEl.value = '';
            if (counterEl) counterEl.textContent = '0 / 2000';
            if (parentEl) parentEl.value = '';
            if (replyBar) replyBar.hidden = true;
            if (alertEl) {
              alertEl.textContent = res.body.message || "Izohingiz qo'shildi.";
              alertEl.className = 'film-comments__alert film-comments__alert--ok';
              alertEl.hidden = false;
            }
            load(false);

            return;
          }

          var msg = 'Izoh yuborilmadi.';
          if (res.status === 422 && res.body && res.body.errors) {
            msg = Object.keys(res.body.errors).map(function (k) { return res.body.errors[k].join(' '); }).join(' ');
          } else if (res.status === 429) {
            msg = "Juda ko'p izoh yubordingiz. Bir daqiqadan keyin qayta urinib ko'ring.";
          } else if (res.body && res.body.message) {
            msg = res.body.message;
          }

          if (alertEl) {
            alertEl.textContent = msg;
            alertEl.className = 'film-comments__alert film-comments__alert--error';
            alertEl.hidden = false;
          }
        }).catch(function () {
          if (alertEl) {
            alertEl.textContent = 'Tarmoq xatosi. Qayta urinib ko\'ring.';
            alertEl.className = 'film-comments__alert film-comments__alert--error';
            alertEl.hidden = false;
          }
        }).then(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Izoh qoldirish'; }
        });
      });
    }

    load(false);
  }

  ready(function () {
    wireShare(); // pleer sahifasida `#filmDetail` yo'q, lekin ulashish bor
    var root = document.getElementById('filmDetail');
    if (!root) return;
    wireRating(root);
    wireComments();
  });
})(window);
